<header>
    <nav class="navbar-simple navbar navbar-expand-lg navbar-light bg-light fixed-top navbar-scroll-bhr is-visible">
        <a class="navbar-brand" href="{{links.home}}">
            <img src="/assets/logo.png" alt="Logo Superefectivo" class="img-fluid">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar-dropdown" aria-controls="" aria-expanded="false" aria-label="Toggle navigation" (click)="togglerDropDown()">
            <span class="navbar-toggler-icon">
                <fa-icon [icon]="faBars"></fa-icon>
            </span>
        </button>
        <div class="navbar-collapse justify-content-end collapsing-custom d-flex" id="navbar-dropdown" [ngClass]="{'active': showDropDown,
            'd-flex': responsiveMenu, 'justify-content-center': responsiveMenu, 'hide-private-area': showPersonalDataNav}">

            <ul class="navbar-nav mt-2 mt-lg-0" *ngIf="!showPersonalDataNav">

                <li class="nav-item">
                    <a href="{{links.compro_oro}}" class="nav-link">
                        COMPRO ORO
                    </a>
                </li>
                <li class="nav-item">
                    <a href="{{links.venta_recuperable}}" class="nav-link">
                        venta recuperable
                    </a>
                </li>
                <li class="nav-item d-block d-lg-none">
                    <a href="/contacto" class="nav-link">
                        outlet de joyas
                    </a>
                </li>
                <li class="nav-item">
                    <a href="{{links.sostenibilidad}}" class="nav-link">
                        sostenibilidad
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link nav-link-client-area" routerLink="/">
                        ÁREA DE CLIENTES
                    </a>
                </li>
                <li class="nav-item d-block d-lg-none phone-number">
                    <a class="nav-link " href="tel:900101471">
                        <img class="opening-icons" src="../../../Assets/angular/assets/img/navbar/phone-icon.png" alt="phone" /> 900 10 14 71
                    </a>
                </li>
                <li class="nav-item d-block d-lg-none">
                    <a class="nav-link">
                        <img class="opening-icons" src="../../../Assets/angular/assets/img/navbar/clock-icon.png" alt=""> 09:00-18:00 L-V
                    </a>
                </li>

            </ul>

            <div class="nav-personal-area-{{siteProfile}} navbar-nav nav-personal-area mt-2 mt-lg-0  " *ngIf="showPersonalDataNav" [ngClass]="{'p-0': responsiveMenu}">
                <div class="nav-item text-center">
                    <a style="color:#E8C681 !important; font-weight:700;" class="nav-link client-area" routerLink="/">
                        ÁREA DE CLIENTES
                    </a>
                </div>
                <div class="account-data">
                    <div class="nav-item  text-center">

                        <a style="color: #fff !important;" id="link-contract" class="nav-link" [routerLinkActive]="['link-active']" routerLink="/contratos" (click)="togglerDropDown()">
                            CONTRATOS
                        </a>
                    </div>
                    <div style="color: #fff !important;" class="nav-item  text-center">
                        <a id="link-personal-data" class="nav-link" [routerLinkActive]="['link-active']" routerLink="/datos" (click)="togglerDropDown()">
                            MIS DATOS
                        </a>
                    </div>
                    <div style="color: #fff !important;" class="nav-item  text-center">
                        <a class="nav-link" (click)="showLogOutModal()">
                            CERRAR SESIÓN
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</header>

<app-modal [attr.id]="modalId" [modalId]="modalId" class="d-none">
    <div class="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-sm-10 offset-sm-1 col-12 offset-0 text-center message-container my-5">
        <p>{{textMessage}}</p>
        <button class="button-modal btn btn-primary" (click)="clientService.logout()">Cerrar sesión</button>
    </div>
</app-modal>
